function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// We should merge this with code in @macrostrat/mapbox-react/src/terrain.ts:
export function enable3DTerrain(map, shouldEnable) {
  var _ref;

  var sourceID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var demSourceID = (_ref = sourceID !== null && sourceID !== void 0 ? sourceID : getTerrainSourceID(map)) !== null && _ref !== void 0 ? _ref : "mapbox-dem";
  console.log("Enabling 3D terrain with source", demSourceID);

  if (!map.style._loaded) {
    map.once("style.load", function () {
      enable3DTerrain(map, shouldEnable, demSourceID);
    });
    return;
  } // Enable or disable terrain depending on our current desires...


  var currentTerrain = map.getTerrain();

  if (!shouldEnable) {
    if (currentTerrain != null) map.setTerrain(null);
    return;
  }

  if (currentTerrain != null) return; // Add a DEM source if one is not found already.

  if (map.getSource(demSourceID) == null) {
    map.addSource(demSourceID, {
      type: "raster-dem",
      url: "mapbox://mapbox.mapbox-terrain-dem-v1",
      tileSize: 512,
      maxzoom: 14
    });
  } // add a sky layer that will show when the map is highly pitched


  if (map.getLayer("sky") == null) {
    map.addLayer({
      id: "sky",
      type: "sky",
      paint: {
        "sky-type": "atmosphere",
        "sky-atmosphere-sun": [0.0, 0.0],
        "sky-atmosphere-sun-intensity": 15
      }
    });
  }

  map.setTerrain({
    source: demSourceID,
    exaggeration: 1
  });
}

function getTerrainSourceID(map) {
  for (var _i = 0, _Object$entries = Object.entries(map.getStyle().sources); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        source = _Object$entries$_i[1];

    if (source.type == "raster-dem") {
      return key;
    }
  }

  return null;
}